import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import _ from "lodash";
import VueCompositionApi, { computed, watch } from "@vue/composition-api";
import * as configuration from "./helpers/configuration";
import axios from "axios";
import { shopifyAppVersion } from "./helpers/consts";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import Hotjar from "vue-hotjar";
import VueMixpanelBrowser from "vue-mixpanel-browser";
import { MazPhoneNumberInput } from "maz-ui";

Vue.use(MazPhoneNumberInput);
Vue.use(VueCompositionApi);
Vue.config.productionTip = false;
if (configuration.HOTJAR_KEY) {
  Vue.use(Hotjar, {
    id: configuration.HOTJAR_KEY,
  });
}
if (configuration.MIXPANEL_KEY) {
  Vue.use(VueMixpanelBrowser, {
    token: configuration.MIXPANEL_KEY,
  });
}

new Vue({
  setup(props, context): any {
    const appReady: any = computed(() => context.root.$store.state.appReady);
    const route: any = computed(() => context.root.$route);
    watch(
      () => route.value,
      (first, second) => {
        if (!_.isEmpty(first.query)) {
          console.log(first);
          console.log(context.root.$store.state.appReady);
          context.root.$store.dispatch("updateQuery", first.query);
          if (!context.root.$store.state.appReady) {
            const shop = first.query.shop;
            const token = first.query.token;
            const timestamp = first.query.timestamp;
            const hmac = first.query.hmac;
            const host = first.query.host;
            const queryString = first.fullPath.slice(2);

            if (configuration.BUGSNAG_KEY) {
              Bugsnag.start({
                apiKey: configuration.BUGSNAG_KEY,
                plugins: [new BugsnagPluginVue()],
                onError: function(event) {
                  event.addMetadata("company", {
                    name: shop,
                  });
                },
              });
              Bugsnag.getPlugin("vue").installVueErrorHandler(Vue);
            }

            const url = configuration.APP_API_URL;
            if (hmac && timestamp && shop) {
              // always check to see if the hmac, timestamp and shop are in the query string. If not redirect the
              // user to the listing page for the app other proceed with the verification
              axios
                .post(
                  `${url}${configuration.APP_API_VERSION}/stores/${shop}:verify`,
                  {
                    queryString,
                  }
                )
                .then((res) => {
                  context.root.$store.dispatch("updateStore", {
                    ...res.data,
                    host,
                  });

                  // Check if window.CONFIG is defined
                  // @ts-ignore
                  if (configuration.APP_API_KEY) {
                    // Create and append the meta tag
                    const meta = document.createElement("meta");
                    meta.name = "shopify-api-key";
                    // @ts-ignore
                    meta.content = configuration.APP_API_KEY;
                    document.head.appendChild(meta);

                    // Create and append the script tag
                    const script = document.createElement("script");
                    script.src =
                      "https://cdn.shopify.com/shopifycloud/app-bridge.js";
                    document.head.appendChild(script);
                  }

                  context.root.$store.dispatch("shop/getStoreBalance");

                  // @ts-ignore
                  context.root.$mixpanel.identify(res.data.name);

                  // @ts-ignore
                  context.root.$mixpanel.register({
                    $email: res.data.email,
                    $name: res.data.name,
                    $distinct_id: res.data.name,
                  });

                  // @ts-ignore
                  context.root.$mixpanel.people.set({
                    $email: res.data.email,
                    $name: res.data.name,
                    $distinct_id: res.data.name,
                  });

                  // @ts-ignore
                  context.root.$mixpanel.track("Shop Sign In");

                  if (res.data.onboardingState === "ONBOARDED") {
                    if (first.query.campaign) {
                      context.root.$store
                        .dispatch("shop/getCustomerCount")
                        .then((res) => {
                          if (res > 2000) {
                            context.root.$store.commit(
                              "setLoadingSubsFailed",
                              false,
                              { root: true }
                            );
                            return;
                          }
                          context.root.$store.dispatch(
                            "shop/getSubscriberCount"
                          );
                        });
                      context.root.$router.push(
                        `/campaigns/${first.query.campaign}/edit`
                      );
                    } else {
                      context.root.$store
                        .dispatch("shop/getCustomerCount")
                        .then((res) => {
                          if (res > 2000) {
                            context.root.$store.commit(
                              "setLoadingSubsFailed",
                              false,
                              { root: true }
                            );
                            return;
                          }
                          context.root.$store.dispatch(
                            "shop/getSubscriberCount"
                          );
                        });
                      context.root.$router.push("/");
                    }
                    context.root.$store.dispatch("updateAppReady", true);
                  } else {
                    context.root.$store
                      .dispatch("shop/getCustomerCount")
                      .then((res) => {
                        if (res > 2000) {
                          context.root.$store.commit(
                            "setLoadingSubsFailed",
                            false,
                            { root: true }
                          );
                          return;
                        }
                        context.root.$store.dispatch("shop/getSubscriberCount");
                      });
                    context.root.$router.push("/onboarding");
                    context.root.$store.dispatch("updateAppReady", true);
                  }
                })
                .catch((err) => {
                  // if the shop is not found but the there is a token in the query, register the store.
                  // if the shop is not found but the there is no token in the query, set redirect to true.
                  // This is so that later in the lifecycle we can redirect the user to the auth page.
                  console.log("verification failed.", err.response);
                  if (token || token !== undefined) {
                    console.log("Token found, registering new store");
                    axios
                      .post(
                        `${url}${configuration.APP_API_VERSION}/stores:register`,
                        {
                          name: `stores/${shop}`,
                          shopifyAccessToken: token,
                          shopifyAuthVersion: shopifyAppVersion,
                        }
                      )
                      .then((res) => {
                        console.log(res);
                        context.root.$store.dispatch("updateStore", res.data);
                        // @ts-ignore
                        context.root.$mixpanel.identify(res.data.name);

                        // @ts-ignore
                        context.root.$mixpanel.register({
                          $email: res.data.email,
                          $name: res.data.name,
                          $distinct_id: res.data.name,
                        });

                        // @ts-ignore
                        context.root.$mixpanel.people.set({
                          $email: res.data.email,
                          $name: res.data.name,
                          $distinct_id: res.data.name,
                        });

                        // @ts-ignore
                        context.root.$mixpanel.track("Shop Install");

                        if (res.data.onboardingState === "ONBOARDED") {
                          context.root.$store.dispatch("shop/getStoreBalance");
                          context.root.$store
                            .dispatch("shop/getCustomerCount")
                            .then((res) => {
                              if (res > 2000) {
                                context.root.$store.commit(
                                  "setLoadingSubsFailed",
                                  false,
                                  { root: true }
                                );
                                return;
                              }
                              context.root.$store.dispatch(
                                "shop/getSubscriberCount"
                              );
                            });

                          context.root.$router.push("/");
                          context.root.$store.dispatch("updateAppReady", true);
                        } else {
                          context.root.$store.dispatch("shop/getStoreBalance");
                          context.root.$router.push("/onboarding");
                          context.root.$store.dispatch("updateAppReady", true);
                        }
                      })
                      .catch((err) => {
                        console.log(
                          "New store failed to register, redirect to auth endpoint"
                        );
                        window.location.assign(
                          `${configuration.APP_URL}/auth?shop=` + shop
                        );
                        console.log(err.response);
                      });
                  } else {
                    console.log("No token found, redirecting to auth endpoint");
                    console.log(err.response);

                    if (err.response.status == 403) {
                      const disabledReason =
                        err.response.headers["grpc-message"] ??
                        err.response.data.message;
                      // @ts-ignore
                      context.root.$mixpanel.track("Banned Store");
                      // Redirect to error page
                      context.root.$router.push(
                        "/error?reason=" + disabledReason
                      );

                      context.root.$store.dispatch("updateAppReady", true);
                    } else {
                      // @ts-ignore
                      context.root.$mixpanel.track("Shop Sign In Fail");
                      // Auth endpoint redirect
                      window.location.assign(
                        `${configuration.APP_URL}/auth?shop=` + shop
                      );
                    }
                  }
                });
            }
          }
        }
      }
    );
  },
  router,
  store,
  // @ts-ignore
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
